module.exports = __webpack_public_path__ + "static/media/slider7.d953502e.jpg";